var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 0.75C16.5 0.335786 16.1642 0 15.75 0C15.3358 0 15 0.335786 15 0.75V3H9V0.75C9 0.335786 8.66421 0 8.25 0C7.83579 0 7.5 0.335786 7.5 0.75V3H4.25C2.73122 3 1.5 4.23122 1.5 5.75V19.75C1.5 21.2688 2.73122 22.5 4.25 22.5H19.75C21.2688 22.5 22.5 21.2688 22.5 19.75V5.75C22.5 4.23122 21.2688 3 19.75 3H16.5V0.75ZM7.5 6.25V4.5H4.25C3.55964 4.5 3 5.05964 3 5.75V9H21V5.75C21 5.05964 20.4404 4.5 19.75 4.5H16.5V6.25C16.5 6.66421 16.1642 7 15.75 7C15.3358 7 15 6.66421 15 6.25V4.5H9V6.25C9 6.66421 8.66421 7 8.25 7C7.83579 7 7.5 6.66421 7.5 6.25ZM21 10.5H3V19.75C3 20.4404 3.55964 21 4.25 21H19.75C20.4404 21 21 20.4404 21 19.75V10.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar.bd1dcd3ccf6fba8f542ca356e1187b51.svg";